// dev_lp — section heading with a centered gradient accent underline (WIX touch).
import React from "react";

interface Props {
  children: React.ReactNode;
  className?: string;
}

const SectionHeading: React.FC<Props> = ({ children, className = "" }) => (
  <div className={`text-center ${className}`}>
    <h2
      className="text-2xl md:text-4xl font-extrabold tracking-tight"
      style={{ color: "#003B7B" }}
    >
      {children}
    </h2>
    <span
      className="mt-4 inline-block h-1.5 w-16 rounded-full bg-gradient-to-l from-blue-600 to-sky-400"
      aria-hidden="true"
    />
  </div>
);

export default SectionHeading;
